export default "__VITE_ASSET__D0KLn28N__"